import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, Teleport as _Teleport, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "print-wrapper" }

import { usePrint } from './use-print';


export default /*#__PURE__*/_defineComponent({
  __name: 'PrintController',
  setup(__props) {

const printStore = usePrint();

return (_ctx: any,_cache: any) => {
  return (_unref(printStore).data)
    ? (_openBlock(), _createBlock(_Teleport, {
        key: 0,
        to: "body"
      }, [
        _createElementVNode("div", _hoisted_1, [
          (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(printStore).data.component), _normalizeProps(_guardReactiveProps(_unref(printStore).data.props || {})), null, 16))
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})